import {Layout} from '../../layout'
import {Text} from '../../text'
import {Icon} from '../../icon'
import {useFilterContext} from '../context'

export const ClearFiltersButton = () => {
	const {clearFilters, hasFiltered} = useFilterContext()

	if (!hasFiltered) return null

	return (
		<Layout onClick={clearFilters} height={24} padding="6 6 6 8" colorSet="color-bordered-outline" baseColor="red" border borderRadius>
			<Icon name="cross-small" size={12} />
			<Text t="filters.clear_filters" small semiBold noTextSelect />
		</Layout>
	)
}
